import React from 'react';
import Highcharts from 'highcharts/highcharts';
import HighchartsReact from 'highcharts-react-official';
import { InlineMath, BlockMath } from 'react-katex';
import 'katex/dist/katex.min.css';

import orig from './orig';
import adj from './adj';

const base = {
  credits: {
    enabled: false
  },
  plotOptions: {
    series: {
      enableMouseTracking: false,
      lineWidth: 1,
      marker: { enabled: true }
    }
  },
  legend: {
    enabled: false
  },
}

const options1 = {
  ...base,
  yAxis: {
    title: { enabled: false },
    min: -20,
    max: 220,
    tickInterval: 20
  },
  xAxis: {
    min: 0,
    max: 15000
  },
  title: {
    text: 'Original',
    margin: 1,
    style: { fontSize: '12px' },
  },
  series: [
    {
      data: orig,
      marker: { radius: 1.5 }
    }
  ]
};

const options2 = {
  ...base,
  yAxis: {
    title: { enabled: false },
    min: -4,
    max: 8,
    tickInterval: 2
  },
  xAxis: {
    min: 0,
    max: 15000
  },
  title: {
    text: 'Rescaled',
    margin: 1,
    style: { fontSize: '12px' },
  },
  series: [
    {
      data: adj,
      marker: { radius: 1.5 }
    }
  ]
};

const opts = { style: { height: '150px', width:'100%' }};
function DNF() {
  return (
    <div className="row">
      <div className="col-12">
        <h5 className="text-uppercase">Degrade-and-Fire</h5>
        <div className="row">
          <div className="col-12 col-xxxl-6">
             <p>
               We utilize a constructed <strong>synthetic gene oscillator</strong> for our degrade-and-fire model.
               The mass-action kinetics of our delayed production and degradation is expressed by the delay-differential equation
             </p>
             <BlockMath>{` \\small \\dot r = \\frac{\\alpha C^{2}_{0}}{(C_{0}+r_{\\tau})} - \\frac{\\gamma_{r}r(t)}{R_{0}+r(t)} - \\beta r(t) `}</BlockMath>
             <p>
               The degrade-and-fire model displays clustering and excess amplitude. To compensate, we rescale the data using <InlineMath>{` \\ln(r) `}</InlineMath>.
             </p>
          </div>
          <div className="col-12 col-xxxl-6">
            <div className="row">
              <div className="col-12 col-xxxl-12">
                <HighchartsReact
                  highcharts={Highcharts}
                  options={options1}
                  containerProps={opts}
                />
              </div>
              <div className="col-12 col-xxxl-12">
                <HighchartsReact
                  highcharts={Highcharts}
                  options={options2}
                  containerProps={opts}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DNF;
